"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicDealerApplicationSchema = exports.dealerApplicationSchema = void 0;
const zod_1 = require("zod");
// Full DB row schema — mirrors Prisma DealerApplication model exactly.
// The `documents` field is hydrated by the dealer service into
// Record<string, { url?: string; key?: string; originalName: string; label: string }[]>
// (presigned URLs), so it is typed as unknown here.
exports.dealerApplicationSchema = zod_1.z.object({
    id: zod_1.z.string(),
    applicationType: zod_1.z.string(),
    companyName: zod_1.z.string(),
    authorizedName: zod_1.z.string(),
    tckn: zod_1.z.string(),
    email: zod_1.z.string(),
    mersisNo: zod_1.z.string(),
    phone: zod_1.z.string(),
    mobile: zod_1.z.string(),
    fax: zod_1.z.string(),
    country: zod_1.z.string(),
    province: zod_1.z.string(),
    district: zod_1.z.string(),
    neighborhood: zod_1.z.string(),
    postalCode: zod_1.z.string(),
    address: zod_1.z.string(),
    taxOffice: zod_1.z.string(),
    taxNo: zod_1.z.string(),
    currency: zod_1.z.string(),
    iban: zod_1.z.string(),
    documents: zod_1.z.unknown(),
    marketingOptIn: zod_1.z.boolean(),
    status: zod_1.z.string(),
    read: zod_1.z.boolean(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
// Multipart form helper: boolean fields arrive as strings from form data
const booleanFromForm = zod_1.z.preprocess((val) => val === true || val === "true" || val === "on" || val === "1", zod_1.z.boolean());
// API verbatim schema (source of truth: apps/api/src/common/schemas.ts)
exports.publicDealerApplicationSchema = zod_1.z.object({
    applicationType: zod_1.z.enum(["tuzel", "gercek"]).default("tuzel"),
    companyName: zod_1.z.string().min(1).max(255),
    authorizedName: zod_1.z.string().min(1).max(255),
    tckn: zod_1.z.string().min(1).max(20),
    email: zod_1.z.string().email().max(255),
    mersisNo: zod_1.z.string().max(50).optional().default(""),
    phone: zod_1.z.string().max(50).optional().default(""),
    mobile: zod_1.z.string().min(1).max(50),
    fax: zod_1.z.string().max(50).optional().default(""),
    country: zod_1.z.string().max(100).optional().default("Türkiye"),
    province: zod_1.z.string().min(1).max(100),
    district: zod_1.z.string().min(1).max(100),
    neighborhood: zod_1.z.string().max(255).optional().default(""),
    postalCode: zod_1.z.string().max(20).optional().default(""),
    address: zod_1.z.string().min(1),
    taxOffice: zod_1.z.string().min(1).max(255),
    taxNo: zod_1.z.string().min(1).max(50),
    currency: zod_1.z.enum(["TRY", "USD", "EUR"]).optional().default("TRY"),
    iban: zod_1.z.string().max(50).optional().default(""),
    kvkkAccepted: booleanFromForm.refine((v) => v === true, "KVKK onayı zorunludur"),
    marketingOptIn: booleanFromForm.optional().default(false),
});
//# sourceMappingURL=dealer.js.map